import * as React from "react";
import { SvgProps } from "../../../utils/interfaces";

const TvSvg: React.FC<SvgProps> = ({
  width,
  height,
  viewBox = "0 0 24 24",
  color = "#000",
  ...rest
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M3.98505 17.3444H20.0151C21.3217 17.3444 22 16.6628 22 15.3594V6.04438C22 4.73373 21.3217 4.05219 20.0151 4.05219H3.98505C2.67834 4.05219 2 4.73373 2 6.04438V15.3594C2 16.6628 2.67834 17.3444 3.98505 17.3444ZM4.00895 16.1945C3.43997 16.1945 3.14996 15.9076 3.14996 15.3387V6.06506C3.14996 5.48896 3.43997 5.20215 4.00895 5.20215H19.9911C20.5601 5.20215 20.8501 5.48896 20.8501 6.06506V15.3387C20.8501 15.9076 20.5601 16.1945 19.9911 16.1945H4.00895ZM7.97109 19.9479H16.029C16.3531 19.9479 16.6072 19.6898 16.6072 19.3761C16.6072 19.0449 16.3531 18.794 16.029 18.794H7.97109C7.64702 18.794 7.39289 19.0449 7.39289 19.3761C7.39289 19.6898 7.64702 19.9479 7.97109 19.9479ZM9.35022 14.0685C9.35022 14.4828 9.78914 14.6387 10.1295 14.4406L15.7778 11.1183C16.1007 10.9202 16.1007 10.4724 15.7707 10.2887L10.1295 6.95915C9.78914 6.76824 9.35022 6.91702 9.35022 7.33131V14.0685Z"
        fill={color}
      />
    </svg>
  );
};

export { TvSvg };
